import React from 'react'
import { Row } from 'antd'
import {
  Image,
  MenuContainer,
  MenuItem,
  MenuText
} from '../../../../shared.style'
import LocationIcon from '../../../../assets/icons/location.png'

const MenuAccountBinLocation = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/account/bin/locations`)}>
          <Image src={LocationIcon} alt="locations" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>สถานที่</MenuText>
      </Row>
    </MenuContainer>
  )
}

export default MenuAccountBinLocation



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountBinLocation/index.js